'use client'

import { Button, type ButtonProps } from '../../buttons/button.tsx'

export const InfoModalButton = (props: ButtonProps) => {
  return <Button {...props} />
}
